import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagPickerDialogComponent } from './tag-picker-dialog.component';
import { MaterialModule } from '@app/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomDirectivesModule } from '@app/_directives/custom-directives.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [TagPickerDialogComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    CustomDirectivesModule,
    TranslateModule,
  ],
  exports: [TagPickerDialogComponent],
})
export class TagPickerDialogModule {}
